import Section from './Section.vue'
import { sortPayinRebateTiersByThresholdAsc } from './tierSort'

const CALCULATE_TYPE_ACCUMULATE = 1
const CALCULATE_TYPE_INDEPENDENT = 2

function createEmptyPayinRebateTier() {
  return {
    id: '',
    threshold_yuan: 100,
    gold_yuan: undefined,
    settled_count: 0,
  }
}

function normalizeTierFromApi(tier, ctx) {
  const { centsToYuanNumber } = ctx
  return {
    id: tier?.id != null ? String(tier.id) : '',
    threshold_yuan: centsToYuanNumber(Number(tier?.threshold_amount) || 0),
    gold_yuan: centsToYuanNumber(Number(tier?.gold) || 0),
    settled_count: Number.isFinite(Number(tier?.settled_count)) ? Number(tier.settled_count) : 0,
  }
}

export const totalDepositRewardModule = {
  type: 8,
  component: Section,
  reset(localForm) {
    localForm.payinRebateTiers = [createEmptyPayinRebateTier()]
    if (localForm.payinRebateRule) {
      localForm.payinRebateRule.calculate_type = CALCULATE_TYPE_ACCUMULATE
      localForm.payinRebateRule.cycle_days = 1
      localForm.payinRebateRule.multiple = 1
    }
    localForm.vips = []
  },
  fillFromActivity(localForm, raw, ctx) {
    const cfg = raw.payin_rebate_config || raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    if (localForm.payinRebateRule) {
      const ct = Number(rule.calculate_type)
      localForm.payinRebateRule.calculate_type =
        ct === CALCULATE_TYPE_INDEPENDENT ? CALCULATE_TYPE_INDEPENDENT : CALCULATE_TYPE_ACCUMULATE
      const cd = Number(rule.cycle_days)
      localForm.payinRebateRule.cycle_days = Number.isFinite(cd) && cd > 0 ? cd : 1
      localForm.payinRebateRule.multiple = Number.isFinite(Number(rule.multiple)) ? Number(rule.multiple) : 1
    }

    if (Array.isArray(cfg.vips)) {
      localForm.vips = cfg.vips.map(v => Number(v)).filter(v => Number.isFinite(v))
    }

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    if (rawTiers.length > 0) {
      localForm.payinRebateTiers = sortPayinRebateTiersByThresholdAsc(rawTiers.map(t => normalizeTierFromApi(t, ctx)))
    } else {
      localForm.payinRebateTiers = [createEmptyPayinRebateTier()]
    }
  },
  validate(localForm, ctx) {
    const { Message, yuanToCents } = ctx
    const rules = localForm.payinRebateRule || {}
    const mult = Number(rules.multiple)
    if (!Number.isFinite(mult) || mult <= 0) {
      Message.error('请输入大于0的奖励稽核倍数')
      return false
    }
    const cycleDays = Number(rules.cycle_days)
    if (!Number.isFinite(cycleDays) || cycleDays < 1) {
      Message.error('请输入大于等于1的循环天数')
      return false
    }

    const tiers = localForm.payinRebateTiers || []
    if (tiers.length === 0) {
      Message.error('请至少配置一条累计存款档位')
      return false
    }

    for (let i = 0; i < tiers.length; i += 1) {
      const t = tiers[i]
      const row = i + 1
      const th = Number(t.threshold_yuan)
      const g = Number(t.gold_yuan)
      if (!Number.isFinite(th) || th <= 0) {
        Message.error(`第${row}行存款达标金额须大于0`)
        return false
      }
      if (!Number.isFinite(g) || g <= 0) {
        Message.error(`第${row}行奖励金额须大于0`)
        return false
      }
    }

    const sortedTiers = sortPayinRebateTiersByThresholdAsc(tiers)
    for (let i = 1; i < sortedTiers.length; i += 1) {
      const prev = yuanToCents(Number(sortedTiers[i - 1].threshold_yuan))
      const cur = yuanToCents(Number(sortedTiers[i].threshold_yuan))
      if (cur <= prev) {
        Message.error('累计存款档位须按门槛从小到大配置，且门槛不能重复或冲突')
        return false
      }
    }
    localForm.payinRebateTiers = sortedTiers
    return true
  },
  buildPayload(localForm, ctx) {
    const { yuanToCents } = ctx

    const rules = localForm.payinRebateRule || {}
    const calculateType =
      Number(rules.calculate_type) === CALCULATE_TYPE_INDEPENDENT ? CALCULATE_TYPE_INDEPENDENT : CALCULATE_TYPE_ACCUMULATE
    const cycleDays = Number(rules.cycle_days)

    const sorted = sortPayinRebateTiersByThresholdAsc(localForm.payinRebateTiers || [])
    const tiers = sorted.map((t, idx) => {
      const payload = {
        index: idx + 1,
        threshold_amount: yuanToCents(Number(t.threshold_yuan)) || 0,
        gold: yuanToCents(Number(t.gold_yuan)) || 0,
        settled_count: Number.isFinite(Number(t.settled_count)) ? Number(t.settled_count) : 0,
      }
      if (t.id != null && t.id !== '') payload.id = String(t.id)
      return payload
    })

    return {
      payin_rebate_config: {
        description: '',
        rule: {
          calculate_type: calculateType,
          cycle_days: Number.isFinite(cycleDays) && cycleDays > 0 ? cycleDays : 1,
          multiple: Number(rules.multiple) || 0,
        },
        vips: [...(localForm.vips || [])].sort((a, b) => a - b),
        tiers,
      },
    }
  },
}

